export default "__VITE_ASSET__CEoNpxlC__"